import { useAppTFunction } from '@dap/common/i18n';
import { Stack } from '@mui/material';
import { DraggableFieldArray, DraggableFieldArrayItem, TextInputField } from '@shared/components';
import {
  Control,
  FieldArrayWithId,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFieldArrayMove,
} from 'react-hook-form';
import { Controller } from 'react-hook-form';

interface PropertyMapValueFieldProps {
  control: Control<any>;
  fields: FieldArrayWithId<any, 'options'>[];
  append: UseFieldArrayAppend<any, 'options'>;
  remove: UseFieldArrayRemove;
  move: UseFieldArrayMove;
  label?: string;
  error?: string;
  includeSelected?: boolean;
}

export default function PropertyMapValueField({
  control,
  fields,
  append,
  remove,
  move,
  label,
  error,
  includeSelected = false,
}: PropertyMapValueFieldProps) {
  const t = useAppTFunction();

  return (
    <DraggableFieldArray
      margin="normal"
      onAdd={() => {
        append(
          includeSelected ? { label: '', value: '', selected: false } : { label: '', value: '' }
        );
      }}
      label={label || ''}
      addButtonLabel={t('common.add')}
      name="options"
      error={error}
      fullWidth
      enableDragAndDrop={true}
      onDragEnd={(result) => {
        if (!result.destination) return;
        move(result.source.index, result.destination.index);
      }}
    >
      {fields.map((fieldItem, index) => (
        <DraggableFieldArrayItem
          key={fieldItem.id}
          onRemove={() => remove(index)}
          removeButtonLabel={t('common.remove')}
          inputSize="small"
          inputMargin="none"
          index={index}
          draggableId={fieldItem.id}
          enableDragAndDrop={true}
        >
          <Stack direction="row" flexGrow={1} gap={1}>
            <Controller
              name={`options.${index}.label`}
              control={control}
              defaultValue=""
              render={(props) => (
                <TextInputField
                  label={''}
                  {...props.field}
                  value={props.field.value ?? ''}
                  size="small"
                  error={props.fieldState.error?.message}
                  margin="none"
                  required
                  fullWidth
                  placeholder={t('memberadmin.properties.options.placeholder.key', {
                    count: index + 1,
                  })}
                />
              )}
            />
            <Controller
              name={`options.${index}.value`}
              control={control}
              defaultValue=""
              render={(props) => (
                <TextInputField
                  {...props.field}
                  value={props.field.value ?? ''}
                  size="small"
                  error={props.fieldState.error?.message}
                  margin="none"
                  required
                  fullWidth
                  placeholder={t('memberadmin.properties.options.placeholder.value', {
                    count: index + 1,
                  })}
                />
              )}
            />
          </Stack>
        </DraggableFieldArrayItem>
      ))}
    </DraggableFieldArray>
  );
}
